import { render, staticRenderFns } from "./passForm.vue?vue&type=template&id=290b6c96&scoped=true"
import script from "./passForm.vue?vue&type=script&lang=js"
export * from "./passForm.vue?vue&type=script&lang=js"
import style0 from "./passForm.vue?vue&type=style&index=0&id=290b6c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290b6c96",
  null
  
)

export default component.exports